import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
import { Global } from 'src/global';
import { InformeConsultaExtractoComponent } from '../pages/cliente-tarjeta/reportes/informe-consulta-extracto/informe-consulta-extracto.component';

@Injectable({
  providedIn: 'root'
})
export class ReporteService extends BaseService {

    prefix = Global.PREFIX_RECORD;


    async setFiltroStorage( codigoReporte: string, filtros: Record<string, any> | null ) {
        localStorage.setItem(`${this.prefix}.reporte.${codigoReporte}`, JSON.stringify(filtros))
    }

    async getFiltroStorage( codigoReporte: string ) {
        return JSON.parse(localStorage.getItem(`${this.prefix}.reporte.${codigoReporte}`));
    }

    async informePrestamo( filtros: Record<string, any> ) {
        this.url = `${environment.host}/reporte/informe-prestamo`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async informeExtractoEnviado( filtros: Record<string, any>) {
        this.url = `${environment.host}/reporte/informe-extracto-enviado`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    async listadoRendicion( filtros: Record<string, any>) {
        this.url = `${environment.host}/reporte/listado-rendicion`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async listadoRendicionCaja( filtros: Record<string, any>) {
        this.url = `${environment.host}/reporte/listado-rendicion-caja`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async informeTarjeta( filtros: Record<string, any>) {
        this.url = `${environment.host}/reporte/informe-tarjeta`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async seguimientoPrestamo( filtros: Record<string, any> ) {
        this.url = `${environment.host}/reporte/seguimiento-prestamo`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async informeNotificacion( filtros: Record<string, any> ) {
        this.url = `${environment.host}/reporte/informe-notificacion`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async informeNotificacionDetalle(id: number, filtros: Record<string, any>) {
        this.url = `${environment.host}/reporte/informe-notificacion/${id}/detalle`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async informeVendedor( filtros: Record<string, any>) {
        this.url = `${environment.host}/reporte/informe-vendedor`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async gestionCartera( filtros: Record<string, any> ) {
        this.url = `${environment.host}/reporte/gestion-cartera`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async informePagare( filtros: Record<string, any>) {
        this.url = `${environment.host}/reporte/informe-pagare`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async informeConsultaExtracto( filtros: Record<string , any> ) {
        this.url = `${environment.host}/reporte/informe-consulta-extracto`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async recuperarCorreos( filtros: Record<string , any> ) {
        this.url = `${environment.host}/reporte/recuperar-correos`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async verificarCorreos( filtros: Record<string , any> ) {
        this.url = `${environment.host}/reporte/verificar-correos`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

}
